import { useEffect, useCallback } from "react";
import { CirclePlus } from "lucide-react";
import Card from "./CardForEvent";

const CardsGroup = ({ 
    register, 
    errors, 
    setValue, 
    watch,
    groupName,
    fields,
    fieldTitle,
    userCanAdd = true,
    onDeleteItem, // 新增刪除項目的回呼函數
    parentId, // 新增父項目的 ID（例如 eventDay 的 ID）
}) => {
    // 只監聽當前組的項目
    const watchItems = watch(groupName) || [];

    const addItem = useCallback(() => {
        const newItem = fields.reduce((acc, field) => {
            acc[field.name] = '';
            return acc;
        }, {});
        
        setValue(groupName, [...watchItems, newItem], {
            shouldValidate: true,
            shouldDirty: true,
            shouldTouch: false
        });
    }, [fields, groupName, setValue, watchItems]);
  
    const removeItem = useCallback(async (index) => {
        const itemToRemove = watchItems[index];
        
        // 如果有提供刪除函數且該項目有 ID，則先呼叫 API
        if (onDeleteItem && itemToRemove?.id) {
            try {
                await onDeleteItem(itemToRemove.id, parentId);
            } catch (error) {
                console.error("Failed to delete item:", error);
                // 如果刪除失敗，可以在這裡處理錯誤，例如顯示錯誤訊息
                return; // 如果API調用失敗，不繼續刪除前端數據
            }
        }
        
        // 從前端數據中移除項目
        const newItems = watchItems.filter((_, i) => i !== index);
        setValue(groupName, newItems, {
            shouldValidate: true,
            shouldDirty: true,
            shouldTouch: false
        });
    }, [groupName, setValue, watchItems, onDeleteItem, parentId]);
  
    return (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {Array.isArray(watchItems) && watchItems.map((item, index) => (
                <Card
                    key={`${groupName}-${index}`}
                    index={index}
                    fields={fields}
                    register={register}
                    errors={errors}
                    onRemove={() => removeItem(index)}
                    groupName={groupName}
                />
            ))}
            
            {userCanAdd && (
                <button
                    type="button"
                    onClick={addItem}
                    className="my-auto p-2 w-fit h-fit flex flex-col items-center justify-center text-gray-500 hover:text-gray-700 hover:border-gray-400"
                >
                    <CirclePlus size={32} strokeWidth={1} />
                    <span className="mt-1 text-sm">新增</span>
                </button>
            )}
        </div>
    );
};

export default CardsGroup;